export default "__VITE_ASSET__DMsV_pe9__"